import allImgPaths from 'assets/images'
import { InputTextField } from 'components/InputField'
import Otp from 'components/Otp'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import objectiveIcon from "./../../assets/images/objective-icon.svg";
import CustomSelect from 'components/common/CustomSelect'
import useVendorHook from 'hooks/vendor/useVendor'
import useAppState from 'context/useAppState'
import { cloneDeep } from 'lodash'

const Onboarding2 = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState<any>({
        business: '',
        description: '',
        years: '',
        registration_number: '',
        business_logo: '',
        website: ''
    });
    const { setState: setVendorState, vendorData, callVendorDataAPI, fetchVendorData } = useAppState('vendorHook')

    useEffect(() => {
        if (callVendorDataAPI) {
            fetchVendorData()
        }
    }, [callVendorDataAPI])

    useEffect(() => {
        console.log({ ob2: vendorData })
        setVendorInfo()
    }, [vendorData])

    const setVendorInfo = () => {

    }

    const handleInputChange = (name: string, value: any) => {
        const clonedFormData = cloneDeep(formData)
        clonedFormData[name] = value;
        setFormData(clonedFormData)

        console.log({ clonedFormData })
    }

    const handleDescriptionChange = (event: any) => {
        handleInputChange('description', event.target.value)

        if (event.target.name === "description") {
            let getTextArea = document.getElementById("textAreaRef");
            if (getTextArea) {
                if (event.target.value.length === 0) {
                    event.target.style.height = "24px";
                } else {
                    event.target.style.height = "auto";
                    event.target.style.height = event.target.scrollHeight + "px";
                }
            }
        }
    };

    const handleFileChange = (name: string, event: any) => {
        const file = event?.target.files[0]
        console.log({ name, file })
    }

    const handleButtonClick = (event: any) => {
        event?.preventDefault()
        document.getElementById('file-input')?.click();
    }

    const gotoPrev = () => {
        // setVendorState({ callVendorDataAPI: true })
        navigate('/vendor/onboarding1')
    }

    return (
        <div className="flex">
            {/* Left banner */}
            <div className="w-2/6">
                <div className="bg-[#1E0AF5] flex flex-col justify-start items-center h-screen">
                    <div className="pt-[77px]">
                        <img className='pb-52 -ml-8' src={allImgPaths.vendorWhiteIcon} alt="" />

                        <div className="pb-10 last:pb-0 relative line-shape done">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Basic Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>General Information</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Contact Info</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Social Media Presence</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape active">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Facility Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Count & capacity</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Secondary services & features</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Legal & Compliances</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Upload licenses, certification & Insurance</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {/* Right banner */}
            <div className="w-4/6 flex flex-col">
                <div className="w-full h-screen flex items-center overflow-y-auto">
                    <div className="w-full max-w-[650px] mx-auto">


                        {/* Heading */}
                        <h2 className="font-interSemiBold text-[30px] text-[#101828] pb-8">Basic Details</h2>

                        {/* Form */}
                        <form>
                            <span className='text-sm text-[#667085] inline-block pb-2'>General Information</span>

                            <div className="mb-4">
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1">Business Name</p>
                                <InputTextField
                                    label={""}
                                    name={"business"}
                                    placeholder={"Enter Here"}
                                    onChange={(e: any) => { handleInputChange('business', e.target.value) }}
                                    value={formData.business}
                                    type="text"
                                />
                            </div>


                            <div className="mb-4">
                                <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                                    Description
                                </p>
                                <div className="relative">
                                    <div className="border border-[#D0D5DD] hover:border-[#1E0AF5] focus-within:border-[#1E0AF5] rounded-lg flex items-start gap-x-2 py-2 px-3">
                                        <img
                                            className="w-[22px] h-[22px] flex-shrink-0 mt-0.5"
                                            src={objectiveIcon}
                                            alt="star icon"
                                        />
                                        <textarea
                                            id="textAreaRef"
                                            name="description"
                                            maxLength={200}
                                            value={formData.description}
                                            onChange={handleDescriptionChange}
                                            className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full h-[24px]"
                                            placeholder="Enter goal of the fete"
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box",
                                                overflow: "hidden",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4">
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1.5">Years in Business</p>
                                <div className="modal-select-box fete-settings-modals">
                                    <CustomSelect
                                        options={
                                            [
                                                { label: "value 1", value: "value 1" },
                                                { label: "value 2", value: "value 2" }
                                            ]
                                        }
                                        onChange={(e: any) => handleInputChange('years', e)}
                                        extendedOption={false}
                                        selectedValue={formData.years}
                                    />
                                    {/* <p className='text-[#D92D20] text-sm pt-0.5'>error</p> */}
                                </div>
                            </div>

                            <div className='mb-4'>
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1">Registration Number</p>
                                <InputTextField
                                    label={""}
                                    name={"registration_number"}
                                    placeholder={"Enter Here"}
                                    onChange={(e: any) => { handleInputChange('registration_number', e.target.value) }}
                                    value={formData.registration_number}
                                    type="text"
                                />
                            </div>

                            <div className="mb-4">
                                <div className="">
                                    <span className='text-[#344054] text-sm font-interMedium pb-2 block'>Business Logo</span>
                                    <input
                                        className="flex items-center gap-x-1.5 border border-[#D0D5DD] hover:border-[#1e0af5] rounded-lg py-2.5 px-3.5"
                                        type="file"
                                        id="file-input"
                                        accept=".jpg,.jpeg,.png"
                                        style={{ display: 'none' }}
                                        onChange={(e: any) => { handleFileChange('business_logo', e) }}
                                    />
                                    <button className="flex items-center gap-x-1.5 border border-[#D0D5DD] hover:border-[#1e0af5] rounded-lg py-2.5 px-3.5 w-full" onClick={handleButtonClick}>
                                        <img src={allImgPaths.vendorFileAttachmentIcon} alt="upload Iocn" />
                                        <span className="text-[#667085]">Click to Browse...</span>
                                    </button>
                                </div>
                            </div>

                            <div className='mb-4'>
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1">Website URL</p>
                                <InputTextField
                                    label={""}
                                    name={"website"}
                                    placeholder={"Enter Here"}
                                    onChange={(e: any) => { handleInputChange('website', e.target.value) }}
                                    value={formData.website}
                                    type="text"
                                />
                            </div>

                        </form>

                        <div className="flex gap-x-3 justify-end mt-10">
                            <button onClick={gotoPrev} className="rounded-md border border-[#1E0AF5] text-[#1E0AF5] hover:bg-[#E8E6FE] flex gap-x-1.5 items-center !pl-2 !pr-4 font-interSemiBold" type="button">
                                <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowBlueIcon} alt="" />
                                Prev
                            </button>
                            <button className="submit-btn-blue blue-btn-hover flex gap-x-1.5 items-center !pl-4 !pr-2" type="submit">
                                Next
                                <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowIcon} alt="" />
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Onboarding2